import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  bookingId: yup.string().uuid().required("Booking ID is required"),

  tripDetail: yup.object().shape({
    tripName: yup.string().required("Trip name is required"),
    tripNumber: yup.string().required("Trip number is required"),
    startingDateTime: yup.date().required("Start date and time is required"),
    endingDateTime: yup.date()
      .required("End date and time is required")
      .min(yup.ref('startingDateTime'), "End date must be after start date"),
    lrNumber: yup.string().required("LR number is required"),
    eWayBill: yup.string().required("E-way bill is required"),
    managingBy: yup.string().uuid().required("ManagingBy is required"),
  }),

  cargoDetails: yup.array().of(
    yup.object().shape({
      cargoItem: yup.string().required("Cargo item is required"),
      cargoType: yup.string().required("Cargo type is required"),
      volume: yup.number().positive("Volume must be a positive number").required("Volume is required"),
      weight: yup.number().positive("Weight must be a positive number").required("Weight is required"),
      count: yup.number().integer().positive("Count must be a positive integer").required("Count is required"),
      unit: yup.string().required("Unit is required"),
      packageType: yup.string().required("Package type is required"),
    })
  ).min(1, "At least one cargo item is required").required("Cargo details are required"),

  routeDetails: yup.array().of(
    yup.object().shape({
      tripRouteId: yup.string().uuid().required("TripRouteId is required"),
    })
  ).optional().nullable(),
});
